const ABBREVIATIONS = new Set(['ae', 'foc', 'hcp', 'pc', 'ccm', 'id', 'sms', 'otp', 'kaps', 'api', 'sgd']);

/**
 * Curated display labels for common workflow / status / transaction keys.
 * Checked before the generic fallback formatter.
 */
const CURATED_LABELS: Record<string, string> = {
  FOC_CYCLE_DISPENSE: 'FOC Dispense',
  ELIGIBILITY_REVIEW: 'Eligibility Review',
  PAID_CYCLE_TRACKING: 'Paid Cycle Tracking',
  PAID_CYCLE_INVOICE_VERIFY: 'Invoice Verification',
  INVOICE_VERIFICATION: 'Invoice Verification',
  PENDING_HCP_APPROVAL: 'Pending HCP Approval',
  HCP_APPROVED: 'HCP Approved',
  PATIENT_ENROLLED: 'Patient Enrolled',
  PATIENT_ENROLLMENT_DRAFT: 'Enrollment Draft',
  PRESCRIPTION_RECEIVED: 'Prescription Received',
  FOC_ELIGIBLE: 'FOC Eligible',
  FOC_ACTIVE: 'FOC Active',
  CYCLE_STARTED: 'Cycle Started',
  PENDING_VALIDATION: 'Pending Validation',
  READY_FOR_APPROVAL: 'Ready for Approval',
  SUBMITTED_FOR_APPROVAL: 'Submitted for Approval',
  CALL_BACK_REQUESTED: 'Callback Requested',
  NOT_CONNECTED: 'Not Connected',
  REJECTED_WITHDRAWN: 'Rejected / Withdrawn',
  COMPLETED: 'Completed',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  REVERSAL: 'Reversal',
  ADJUSTMENT: 'Adjustment',
  APPROVAL: 'Approval',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  SUSPENDED: 'Suspended',
  PENDING: 'Pending',
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  ARCHIVED: 'Archived',
  UNDER_REVIEW: 'Under Review',
  REJECTED: 'Rejected',
  CLOSED: 'Closed',
  APPROVED: 'Approved',
  ENROLLED: 'Enrolled',
  CREATE: 'Create',
  EDIT: 'Edit',
  DELETE: 'Delete',
  SUBMIT: 'Submit',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  ESCALATE: 'Escalate',
  TRANSITION: 'Transition',
  MISSING_INVOICE: 'Missing Invoice',
  AWAITING_VALIDATION: 'Awaiting Validation',
  UPCOMING_CYCLE: 'Upcoming Cycle',
  PENDING_APPROVAL: 'Pending Approval',
  EXCEPTION_REVIEW: 'Exception Review',
  ESCALATED: 'Escalated',
  FOLLOW_UP: 'Follow-up',
};

/**
 * Converts technical workflow action strings to user-friendly title case.
 * e.g. "SUBMIT_INVOICE" → "Submit Invoice", "REPORT_EXCEPTION_AE" → "Report Exception AE"
 */
export function formatWorkflowAction(action: string | null | undefined): string {
  if (!action) return '';

  const key = action.trim().toUpperCase();
  if (CURATED_LABELS[key]) return CURATED_LABELS[key];

  return action
    .toLowerCase()
    .split('_')
    .map(word => {
      if (ABBREVIATIONS.has(word)) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}
